import {
  Link as AriaLink,
  type LinkProps as AriaLinkProps,
} from "react-aria-components"

import { cx } from "@uui/utils/cx"

/* Links are always print. Quieter variants step down the ink ladder instead. */
export interface LinkProps extends AriaLinkProps {
  variant?: "primary" | "secondary" | "tertiary" | "muted" | "nav"
}

export const Link = ({
  className,
  variant = "primary",
  ...props
}: LinkProps) => {
  return (
    <AriaLink
      {...props}
      className={cx(
        "focus-visible:outline-focus-ring cursor-pointer transition-colors duration-(--duration-snap) outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        variant === "primary" &&
          "text-brand-secondary hover:text-brand-secondary_hover",
        variant === "secondary" && "text-secondary hover:text-primary",
        variant === "tertiary" && "text-tertiary hover:text-secondary",
        variant === "muted" && "text-quaternary hover:text-secondary",
        variant === "nav" && "text-tertiary hover:text-primary font-medium",
        typeof className === "string" ? className : "",
      )}
    />
  )
}
